import { notification, message } from "antd";

const isNullOrEmpty = (text) =>
  text === undefined || text === "" || text === null;

const isNumber = (value) => matchRegexp(value, /^\d+$/);

const isFloat = (value) => {
  const isFloatx = matchRegexp(value, /^(?:-?[1-9]\d*|-?0)?(?:\.\d+)?$/i);
  return isFloatx;
};

const matchRegexp = (value, regexp) => {
  const validationRegexp =
    regexp instanceof RegExp ? regexp : new RegExp(regexp);
  return validationRegexp.test(value);
};

const notificationSuccess = (message) => {
  notification.success({
    message: "İşlem Başarılı",
    description: message,
  });
};
const notificationError = (message) => {
  notification.error({
    message: "İşlem Başarısız",
    description: message,
  });
};
const notificationWarning = (message) => {
  notification.warning({
    message: "Uyarı",
    description: message,
  });
};

const messageSuccess = (val) => {
  message.success(val);
};
const messageError = (val) => {
  message.error(val);
};
const messageWarning = (val) => {
  message.warning(val);
};

const generateRandomString = (length = 15) => {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

const toUpper = (text) => text?.toLocaleUpperCase("en-US");

const hasAccess = (action) => {
  const userInfo = JSON.parse(localStorage.getItem("userinfo"));
  console.log("userInfo", userInfo);
  if (global.roles !== null) return global?.roles?.has(action);
  else return false;
};
function formatNumber(value) {
  if (value == null) return "";
  // Ondalık kısmı ayır
  const parts = parseFloat(value).toFixed(2).split(".");
  // Binlik ayraçları ekle
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return parts.join(",");
}

export default {
  messageWarning,
  messageError,
  messageSuccess,
  notificationError,
  notificationSuccess,
  notificationWarning,
  hasAccess,
  isNullOrEmpty,
  generateRandomString,
  isNumber,
  isFloat,
  matchRegexp,
  toUpper,
  formatNumber,
};
